import moment from "moment";
import 'moment/locale/th'
moment.locale('th')

  const formatThaiDate = (date) => {
    if(!date) return ''
    const buddhistYear = parseInt(moment(date).format("YYYY")) + 543; // แปลงเป็น พ.ศ.
    return moment(date).format("DD MMMM ") + buddhistYear; // แสดง "วัน เดือน พ.ศ."
  };

export {
  formatThaiDate
}